import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VisitorSliceState } from '../../types/redux/states/VisitorSliceState';
import { NullOr } from '../../types/NullOr';
import { FeatureFlags } from '../../types/FeatureFlags';

export const VisitorSliceInitialState: VisitorSliceState = {
  customerId: null,
  locale: 'en-US',
  plid: null,
  resellerId: 1,
  ventureId: null,
  shopperId: null,
  switchboard: {
    featureFlags: {} as FeatureFlags,
    public: { pusherKey: '' }
  },
  apiError: null
};

export const VisitorSlice = createSlice({
  name: 'visitor',
  initialState: VisitorSliceInitialState,
  reducers: {
    setApiError: (
      state,
      action: PayloadAction<NullOr<{ status: number } & Record<string, unknown>>>
    ) => {
      return {
        ...state,
        apiError: action.payload
      };
    }
  }
});
